/* eslint-disable react/no-danger,react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types,
no-console,no-useless-constructor */
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import ReactTable from 'react-table';
import { withTranslation } from 'react-i18next';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import RouterContext from 'helpers/routerContext';
import AdUser from 'components/common/AdUser';
import AdInfo from 'components/common/AdInfo';
import AdInfoSidebar from 'components/common/AdInfoSidebar';
import { TableLoader } from 'components/common/TableLoader';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import UnPublish from '@material-ui/icons/CloudDownload';
import Publish from '@material-ui/icons/CloudUpload';
import Button from 'components/UI/CustomButtons/Button';
import { adStatus } from 'config';
import WithPermission from 'components/User/WithPermission';
import Card from 'components/UI/Card/Card';
import { LoadingAnimation } from 'components/common/Loading';

class FlaggedAdDetails extends React.Component {
  static contextType = RouterContext;

  /**
   * @description
   * Format the DATE received from the server.
   *
   * @param {string} date - DATE received from the server.
   * @returns {Object} Converted date.
   */
  dateFormat = date => {
    const calendarStrings = {
      lastDay: '[Ayer ] LT',
      sameDay: '[Hoy ] LT',
      lastWeek: '[] dddd[, ] LT',
      sameElse: 'L',
    };
    // 2019-02-08T15:59-0500 date for testing
    return <Moment date={date} calendar={calendarStrings} />;
  };

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @returns {Array} Table columns.
   */
  renderColumns = () => {
    const { classes, t } = this.props;
    return [
      {
        Header: (
          <div className={`${classes.headerField} ${classes.center}`}>
            {t('flagged_ad.details.labelAddress')}
          </div>
        ),
        accessor: 'ip',
        sortable: false,
        filterable: false,
      },
      {
        Header: (
          <div className={`${classes.headerField} ${classes.center}`}>
            {t('flagged_ad.details.labelTotal')}
          </div>
        ),
        accessor: 'total',
        sortable: false,
        filterable: false,
      },
    ];
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All flagged-ip from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { classes } = this.props;
    return edges.map(node => ({
      ip: (
        <div
          className={`${classes.center} ${classes.ipRow}`}
          data-test-id="ip-address"
        >
          {node.ip}
        </div>
      ),
      total: (
        <div className={`${classes.center} ${classes.ipRow}`}>
          {node.totalFlags}
        </div>
      ),
    }));
  };

  /**
   * @description
   * Render Paginator and ReactTable components.
   * @returns {*} Paginator and ReactTable components.
   */
  render() {
    const {
      data,
      classes,
      t,
      adActionLoadingBaseAd,
      adPublishBaseAd,
      adUnPublishBaseAd,
    } = this.props;
    const { flagsIps, ...rest } = data;
    const baseAd = { ad: { ...rest } };
    const baseAdExist = Object.keys(baseAd.ad).length !== 0;
    const cols = this.renderColumns();
    const rows = this.renderRows(flagsIps || []);

    return (
      <div className={classes.pageContainer}>
        <h3 className={classes.title}>{t('flagged_ad.details.title')}</h3>

        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={6}
            lg={4}
            style={{
              overflowY: 'auto',
              maxHeight: '80vh',
            }}
          >
            <div
              style={{
                position: 'sticky',
                zIndex: 2,
                top: 15,
                textAlign: 'center',
              }}
            >
              <Card>
                {adActionLoadingBaseAd ? (
                  <div
                    className={classes.actionsLoader}
                    style={{ padding: '16px 24px' }}
                  >
                    <LoadingAnimation />
                  </div>
                ) : (
                  <div className={classes.permissionsContainer}>
                    {baseAdExist &&
                      (baseAd.ad.status === adStatus.PUBLISHED_BY_MODERATOR ||
                        baseAd.ad.status === adStatus.PUBLISHED_BY_PROCESSOR ||
                        baseAd.ad.status === adStatus.TO_REVIEW) && (
                        <WithPermission allowPermissions={['publish_ad']}>
                          <Tooltip
                            placement="top"
                            TransitionComponent={Zoom}
                            title={
                              <React.Fragment>
                                {t('common.unpublish')}
                                <span className={classes.arrow} />
                              </React.Fragment>
                            }
                            classes={{
                              tooltip: classes.bootstrapTooltip,
                              tooltipPlacementTop:
                                classes.bootstrapPlacementTop,
                            }}
                          >
                            <Button
                              data-cy="adUnpublishButton"
                              simple
                              id="baseAd-unpublish"
                              onClick={() => adUnPublishBaseAd([baseAd.ad.id])}
                              className={classes.actionsBtnLabel}
                              color="danger"
                            >
                              <UnPublish />
                              <span>{t('common.unpublish')}</span>
                            </Button>
                          </Tooltip>
                        </WithPermission>
                      )}
                    {baseAdExist &&
                      (baseAd.ad.status === adStatus.UNPUBLISHED_BY_MODERATOR ||
                        baseAd.ad.status ===
                          adStatus.UNPUBLISHED_BY_PROCESSOR ||
                        baseAd.ad.status === adStatus.TO_REVIEW) && (
                        <WithPermission allowPermissions={['publish_ad']}>
                          <Tooltip
                            placement="top"
                            TransitionComponent={Zoom}
                            title={
                              <React.Fragment>
                                {t('common.publish')}
                                <span className={classes.arrow} />
                              </React.Fragment>
                            }
                            classes={{
                              tooltip: classes.bootstrapTooltip,
                              tooltipPlacementTop:
                                classes.bootstrapPlacementTop,
                            }}
                          >
                            <Button
                              data-cy="adPublishButton"
                              simple
                              color="success"
                              id="baseAd-publish"
                              onClick={() => adPublishBaseAd([baseAd.ad.id])}
                              className={classes.actionsBtnLabel}
                            >
                              <Publish />
                              <span className={classes.actionsBtnLabel}>
                                {t('common.publish')}
                              </span>
                            </Button>
                          </Tooltip>
                        </WithPermission>
                      )}
                  </div>
                )}
              </Card>
            </div>
            {baseAdExist && <AdUser data={baseAd} />}
            {baseAdExist && <AdInfoSidebar data={baseAd} />}
            <AdInfo data={baseAd} loading={!baseAdExist} />
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={6}
            lg={8}
            style={{
              overflowY: 'auto',
              maxHeight: '80vh',
            }}
          >
            <div className={classes.contentContainer}>
              <div
                className={[classes.loadingLineContainer, classes.topLine].join(
                  ' ',
                )}
              >
                {!data.flagsIps && (
                  <LinearProgress
                    classes={{
                      barColorPrimary: classes.loadingLine,
                    }}
                  />
                )}
              </div>
              <GridContainer>
                <GridItem xs={12} className={classes.z3}>
                  {!data.flagsIps ? (
                    <TableLoader />
                  ) : (
                    <ReactTable
                      data={rows}
                      filterable
                      columns={cols}
                      pageSize={data.flagsIps.length}
                      showPagination={false}
                      className={['-striped -highlight', classes.tbl].join(' ')}
                      noDataText={t('common.no_data')}
                      minRows={data.flagsIps ? data.flagsIps.length : 8}
                    />
                  )}
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * FlaggedAdDetails PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop ips query's results
 * @param adActionLoadingBaseAd - prop while executing ad action
 * @param adPublishBaseAd - prop function to execute publish base ad
 * @param adUnPublishBaseAd - prop function to execute publish base ad
 * @param t - prop from HOC with string translations
 */

FlaggedAdDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  adActionLoadingBaseAd: PropTypes.bool.isRequired,
  adPublishBaseAd: PropTypes.func.isRequired,
  adUnPublishBaseAd: PropTypes.func.isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const FlaggedAdDetailsWrapper = props => <FlaggedAdDetails {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(FlaggedAdDetailsWrapper),
);
